<template>
  <v-form @submit.prevent="handleSubmit()" ref="TheForm" role="form" autocomplete="on" enctype="multipart/form-data">
    <div class="form-field" v-for="field in props.formFields" :key="field.name">

      <v-text-field
        v-if="field.type !== 'textarea'"
        v-model="field.value"
        required
        validate-on="lazy blur"
        variant="outlined"
        :type="field.type"
        :name="field.name"
        :label="field.label"
        :append-inner-icon="field.appendInner"
        :rules="field.rules"
        :aria-label="field.ariaLabel ?? ''"
        @input="handleInput($event, field)"
        @focus="handleInput($event, field)" 
        @blur="handleInput($event, field)"
        :disabled="isLoading || isDisabled"
      />

      <v-textarea
        v-else
        v-model="field.value"
        required
        rows="4"
        variant="outlined"
        :name="field.name"
        :label="field.label"
        :rules="field.rules"
        @input="handleChange($event, field.name)"
        :disabled="isLoading || isDisabled"
      />

    </div>
    <div class="form-field">
      <slot name="custom-fields">
      </slot>
    </div>
    <v-btn type="submit" class="default-button" color="primary" :disabled="isLoading || isDisabled" :loading="isLoading">Enviar</v-btn>
  </v-form>
</template>

<script setup lang="ts">
import { VForm, VTextField, VTextarea, VBtn } from 'vuetify/components';

const props = defineProps(['formFields', 'isLoading', 'isDisabled'])
const emit = defineEmits(["input-change", "handle-submit"])

const TheForm = ref<any>(null);

const applyMask = (value: string, mask: string): string => {
  const chars = value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase().slice(0,14);
  let masked = '';
  let charIndex = 0;

  for (let i = 0; i < mask.length && charIndex < chars.length; i++) {
    const maskChar = mask[i];

    if (maskChar === '#') {
      if (/\d/.test(chars[charIndex])) {
        masked += chars[charIndex];
        charIndex++;
      } else {
        break;
      }
    } else if (maskChar === 'A') {
      if (/[a-zA-Z0-9]/.test(chars[charIndex])) {
        masked += chars[charIndex];
        charIndex++;
      } else {
        break;
      }
    } else {
      masked += maskChar;
    }
  }

  return masked;
};

const getCpfCnpjMask = (value: string): string => {
  const chars = value.replace(/[^a-zA-Z0-9]/g, '');
  const hasLetters = /[a-zA-Z]/.test(chars);
  return chars.length > 11 || hasLetters
    ? 'AA.AAA.AAA/AAAA-##'
    : '###.###.###-##';
};

const handleInput = (e: Event, field: any) => {
  const input = e.target as HTMLInputElement;
  let value = input.value;

  if (field.fieldMask === 'cpf/cnpj') {
    const mask = getCpfCnpjMask(value);
    value = applyMask(value, mask);
    input.value = value;
  }

  emit("input-change", { name: field.name, value });
};

const handleChange = (e: Event, name: string) => {
  const input = e.target as HTMLInputElement;
  const value = input.value;
  emit("input-change", { name, value });
};

const handleSubmit = async () => {
  const { valid } = await TheForm.value.validate();

  if (valid) {
    emit("handle-submit");
    TheForm.value.reset();
  };
}

</script>

<style lang="scss">
.form-field .v-field {
  .v-field__outline {
    .v-field__outline__start {
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
    }

    .v-field__outline__end {
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
    }
  }

  &:hover {

    &:not(.v-field--error) {

      .v-field__outline__start,
      .v-field__outline__end {
        border-color: #3303FF;
      }

      .v-field__outline__notch {
        color: #3303FF;
        transition: none !important;
      }
    }
  }

}
</style>